<app-complex-modal-template
    [canConfirm]="fieldInterventionCreationEditionForm.valid && hasFieldInterventionArea()"
    [confirmTooltip]="confirmTooltip()"
    [stepNumber]="1"
    [title]="data.title | transloco"
    (onClickEvent)="onClickEvent($event)">
    <form [formGroup]="fieldInterventionCreationEditionForm">
        <div class="flex flex-col">
            <div class="flex flex-col gap-4">
                <div class="flex flex-row justify-between items-baseline">
                    <mat-form-field
                        appearance="outline"
                        class="w-1/2"
                        floatLabel="always"
                        subscriptSizing="dynamic">
                        <mat-label>{{ 'name' | transloco }}</mat-label>
                        <input
                            #nameInput
                            formControlName="name"
                            matInput
                            type="text"
                            [placeholder]="'defineFieldIntervention' | transloco" />

                        @if (fieldInterventionCreationEditionForm.controls.name.dirty) {
                            <button
                                mat-icon-button
                                matSuffix
                                type="button"
                                [attr.aria-label]="'clear' | transloco"
                                (click)="fieldInterventionCreationEditionForm.controls.name.reset()">
                                <fa-icon [icon]="['fas', 'close']" />
                            </button>
                        }

                        @for (
                            error of fieldInterventionCreationEditionForm.controls.name.errors | keyvalue;
                            track error
                        ) {
                            <mat-error>{{ formService.getErrorMessage(error) }}</mat-error>
                        }
                    </mat-form-field>

                    <app-button
                        [label]="
                            (fieldInterventionCreationEditionForm.controls.fieldInterventionArea.value
                                ? 'changeInterventionArea'
                                : 'defineInterventionArea'
                            ) | transloco
                        "
                        [stackIcon]="{
                            baseIcon: ['far', 'draw-polygon'],
                            topIcon: ['fas', 'pen'],
                            baseIconTransform: 'shrink-2',
                            topIconTransform: 'shrink-6 up-3 right-3',
                        }"
                        [type]="
                            fieldInterventionCreationEditionForm.controls.fieldInterventionArea.value
                                ? ButtonType.SECONDARY
                                : ButtonType.PRIMARY
                        "
                        (onClick)="onDefineInterventionArea()" />
                </div>

                <div class="flex">
                    <mat-form-field
                        appearance="outline"
                        class="w-1/3 h-min"
                        subscriptSizing="dynamic">
                        <mat-label>{{ 'endDate' | transloco }}</mat-label>
                        <input
                            formControlName="scheduledEndDate"
                            matInput
                            [matDatepicker]="picker"
                            [matDatepickerFilter]="customDateAdapterService.datePickerFilter"
                            [placeholder]="dateFormatPlaceHolder" />
                        <mat-datepicker-toggle
                            matIconSuffix
                            [for]="picker" />
                        <mat-datepicker #picker />

                        @for (
                            error of fieldInterventionCreationEditionForm.controls.scheduledEndDate.errors | keyvalue;
                            track error
                        ) {
                            <mat-error>{{ formService.getErrorMessage(error) }}</mat-error>
                        }
                    </mat-form-field>
                    <span class="text-on-surface text-subtitle w-2/3 pl-6">{{ 'endDateInfo' | transloco }}</span>
                </div>
                <mat-form-field
                    appearance="outline"
                    class="pb-2"
                    subscriptSizing="dynamic">
                    <mat-label>{{ 'description' | transloco }}</mat-label>
                    <textarea
                        formControlName="description"
                        matInput
                        rows="4"
                        type="text"
                        [placeholder]="'fieldInterventionDescription' | transloco"></textarea>

                    @for (
                        error of fieldInterventionCreationEditionForm.controls.description.errors | keyvalue;
                        track error
                    ) {
                        <mat-error>{{ formService.getErrorMessage(error) }}</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
    </form>
</app-complex-modal-template>
